// removed by extract-text-webpack-plugin
module.exports = {"Card":"up_9kS6N","Downloads":"MZU8bTb2","Download":"_1HqyI9ID"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/consultation/consultation-page.styles.scss
// module id = 295
// module chunks = 0